import { Box, Avatar } from '@mui/material';
import { css } from '@emotion/react';
import { Color } from '@common/styles/color';
import { IconArrowSelectUrl } from '@src/resources/icon';

export const FileUploadStyle = css`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 50px 20px 30px;
  width: 756px;
  max-width: 100%;
  background-color: #fff;
  text-align: center;

  .title {
    margin-bottom: 50px;
  }
  .filebox {
    margin-bottom: 20px;
    padding: 10px 16px;
    background-color: #fafafa;
    > .filebox--title {
      display: flex;
      align-items: center;
      gap: 8px;
      > .filebox--status {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #727272;
      }
      > .filebox--language {
        display: flex;
        gap: 4px;
        font-weight: 600;
      }
    }
    > .filebox--content {
      text-align: left;
      color: #727272;
    }
  }
  .alertClose {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .lengthCheck {
    position: relative;
    & > span {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 0.75rem;
      s {
        text-decoration: none;
      }
    }
    &.lengthError {
      span s {
        color: red;
      }
      textarea {
        border-color: red;
        &:focus-visible {
          outline: 1px solid red;
        }
      }
      fieldset {
        border-color: red;
      }
    }
  }
  .modal--div--box {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    &.non-scroll {
      overflow: visible;
    }
    &::-webkit-scrollbar {
      width: 7px;
      height: 10px;
      margin: 50px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(213, 211, 228);
      border-radius: 20px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgb(255, 255, 255);
      margin-left: 10px;
    }
    .title {
      text-align: left;
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 8px;
    }
    .valid {
      color: ${Color.compulsory};
      width: 100%;
      text-align: left;
      font-size: 0.75rem;
      margin-left: 14px;
    }
    .color--red {
      color: ${Color.compulsory};
    }
    > strong {
      display: block;
      font-weight: 400;
      text-align: left;
      > span {
        margin-left: 3px;
        color: #e6311a;
      }
    }
    .input--text--wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      > label {
        width: 95px;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        border: 1px solid #cbcbcb;
        border-radius: 2px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .select--wrap {
        display: flex;
        gap: 12px;
        width: calc(100% - 100px);
        > .select--wrap--box {
          position: relative;
          > button {
            padding: 0 14px 0 4px;
            height: 20px;
            font-weight: 500;
            color: #727272;
            background: #f3f3f3 url(${IconArrowSelectUrl}) no-repeat center
              right 4px;
            border-radius: 2px;
          }
          > ul {
            position: absolute;
            padding: 4px 14px;
            text-align: left;
            background-color: #fff;
            border: 1px solid #ececec;
            border-radius: 2px;
            box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.08);
            z-index: 10;
            > li {
              display: inline-block;
              margin: 4px 0;
              padding: 0 4px;
              height: 20px;
              font-weight: 500;
              color: #727272;
              background: #f3f3f3;
              border-radius: 2px;
              cursor: pointer;
            }
          }
        }
        > .file--name {
          flex: 1;
          position: relative;
          font-weight: 400;
          text-align: left;
          &.file--none {
            color: #aaaaaa;
          }
          > .file--err {
            position: absolute;
            top: calc(100% - 5px);
            font-size: 12px;
            color: #e6311a;
          }
        }
      }
    }
    .check-box-wrap {
      margin-bottom: 16px;
      padding-top: 2px;
      > ul {
        display: flex;
        align-items: center;
        gap: 28px;
      }
    }
    .input--text--ci {
      padding: 60px 0 0;
    }
    .input--checkbox--wrap {
      display: flex;
      > div:hover {
        background: transparent;
      }
    }
    .input--checkbox--stockrefine {
      /* display: flex; */
      /* align-items: center; */
      padding: 5px 0;
      > div:hover {
        background: transparent;
      }
    }
  }
  .Mui-selected {
    color: #d463fc !important;
  }
  .MuiTabs-indicator {
    background-color: #d463fc;
  }
`;
